import http from "./Endpoint";
import { appConstant } from "config/constant";

class OrderService {
  /**
   * List orders
   * @param {*} $filter - {
   *     "customer_id": data.customer_id,
   *     "user_id": data.user_id,
   *     "order_status_id_id": data.order_status_id,
   *     "date_from": data.date_from,
   *     "date_to": data.date_to,
   *     "cost_center_id": data.cost_center_id,
   *     "department_id": data.Department_id,
   *     "payment_method_id": data.payment_method_id,
   *     "date_by": data.date_by,
   *     "search_by": data.search_by,
   *     "order_type_id_id": data.order_type_id,
   *     "po_number": ""
   *   }
   * @param [*] extra - [
   *    "found_rows",
   *     "header"
   *   ]}
   */
  query(data) {
    let article = {
      "filter": data.filter,
    }
    if (data.return) {
      article["return"] = data.return;
    }
    if (data.projection) {
      article["projection"] = data.projection;
    }
    if (data.extra) {
      article["extra"] = data.extra;
    }
    return http().post("/orderNew/query", article);
  }

  listOrderProducts(productId) {
    let article = {
      "filter": {
        "customer_id": appConstant.CUSTOMER_ID,
        "product_id": productId,
        "date_from": "2023-09-22",
        "date_to": "2023-09-22"
      },
      "projection": {
        "order_by": {
          "order_id": "DESC",
          "created": "ASC"
        },
        "limit": 500,
        "offset": 0
      },
      "return": []
    }
    return http().post("/orderNew/listOrderProducts", article);
  }

  getById(data) {
    let article = {
      "filter": data.filter,
    }
    if (data.return) {
      article["return"] = data.return;
    }
    return http().post("/orderNew/getById", article);
  }

  addorder(article) {
    return http().post("/orderNew/add", article);
  }

  scoraPlaceOrder(article) {
    return http().post("/orderNew/scoraPlaceOrder", article);
  }

  cancel(article) {
    return http().post("/orderNew/cancel", article);
  }

}

export default new OrderService();